import React, { useState } from 'react';
import {ReactComponent as ActiveIcon} from '../../components/svgs/activeIcon.svg'
import {ReactComponent as SearchIcon} from '../../components/svgs/searchicon.svg';
import {ReactComponent as ExportIcon} from '../../components/svgs/exportIcon.svg';
import {ReactComponent as FilterIcon} from '../../components/svgs/filterIcon.svg';

import { Link } from 'react-router-dom';

const OwnerEmployeesTable = () => {

    const [activeTab, setActiveTab] = useState(0);

  const tabs = [
    {

      tableData: [
        { employeeName: 'Micheal Scott', role: ['Attendant', 'Manager', 'Owner'],emailAddress: 'mike.scott@mail.com', viewButton: '/owner/employees/employees-details' },
        { employeeName: 'Pam Beasley', role: ['Manager'], emailAddress: 'pam.beasly@mail.com', viewButton: '/owner/employees/employees-details' },
        { employeeName: 'Jim Halpert', role: ['Manager', 'Owner'], emailAddress: 'j.halpert@mail.com', viewButton: '#' },
        { employeeName: 'Dwight Shrute', role: ['Attendant'], emailAddress: 'd.schrute@mail.com', viewButton: '#' },
        { employeeName: 'Oscar Martinez', role: ['Attendant', 'Manager', 'Owner'], emailAddress: 'oscar.m@mail.com', viewButton: '#' },
        { employeeName: 'Kevin Malone', role: ['Manager', 'Owner'], emailAddress: 'k.malone@mail.com', viewButton: '#' },
        
      ]
    },
   
  
  ];

  return (
    <>
    <div className="tab-container">

        <section className='flex search-filter-section mt-4 mb-4 ml-4'>
            <section>
                <form action="">
                <label htmlFor="" className="flex flex-col order-search-input">
                    <SearchIcon className='order-search-icon search-icon'/>
                    <input type="text" placeholder="Search" className="mt-2"/>
                </label>
                </form>
            </section>
            <section className='flex gap-10 mt-10 ml-20'>
                <div className='flex gap-4'>
                    <FilterIcon/>
                    <p className='filter-section-text'>Filter</p>

                </div>
                <div className='flex gap-4'>
                    <ExportIcon/>
                    <p className='filter-section-text'>Export as csv</p>
                    
                </div>
            </section>
        </section>    
            

      <div className="tab-content">
        {tabs.map((tab, index) => (
          <div key={index} className={`tab-pane ${activeTab === index ? 'active' : ''}`}>
            <table className="custom-table custom-order-table">

              <thead>
                <tr className='table-head'>
                  <th className=''>
                    Employee name
                    <span className="filter-icon">
                      <ActiveIcon />
                      
                    </span>
                  </th>
                  <th className=''>
                    Role
                    <span className="filter-icon">
                    <ActiveIcon className=''/>
                    </span>
                  </th>
                  <th>
                    Email address
                    <span className="filter-icon">
                    <ActiveIcon />
                    </span>
                  </th>
                </tr>
              </thead>

              <tbody className='table-body'>
                {tab.tableData.map((data, dataIndex) => (
                  <tr key={dataIndex} className='table-row'>
                    <td className='table-data-1'>
                      {data.employeeName}
                      
                    </td>
                   
                    <td className='table-data-1'>
                      {data.role.map((role, roleIndex) => (
                        <span className='role-text mr-6' key={roleIndex}>{role}</span>
                      ))}
                  
                    </td>
                   
                    <td className='table-data'>
                      {data.emailAddress}
                    
                    </td>
                    
                    <td>
                        <Link to={data.viewButton} className='view-btn'>View</Link>
                    </td>
                    
                    
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
    </>
  )
}

export default OwnerEmployeesTable